module.exports = __webpack_public_path__ + "media/seher_1.1a.0915e5c8.mp3";